import _ from 'lodash/fp'
import { take, put, call, takeLatest } from 'redux-saga/effects'
import { makeSaga } from './util'

import { actions as authActions } from '../reducers/auth'
import { types as profileTypes, actions as profileActions } from '../reducers/profile'

import { getEffect, putEffect } from './network'

import gql from 'graphql-tag'
import apolloClient from '../apollo'
import { isLocal } from '../config'

const meQuery = gql`
{
  me {
    id
    name
    handle
    email
    countryCode
    birthday
    visibility
    handicap
    sex
    clubName
    profileFilename
    club {
      id
    }
    externalId
    memberships {
      membershipId
      createdAt
      expiryDate
    }
    isInGLFROpen: isMember(membershipId: "GLFR_OPEN")
  }
}
`

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * loadUserEffect (avoidCache) {
  if (isLocal) {
    try {
      const { data: { me } } = yield call([apolloClient, apolloClient.query], {
        query: meQuery,
        fetchPolicy: 'network-only'
      })
      return { ...me, clubId: _.get('club.id', me) }
    } catch (error) {
      return { error }
    }
  }
  const request = {
    url: 'profile' + (avoidCache ? `?c=${avoidCache}` : '')
  }
  const chan = yield call(getEffect, request)
  return yield take(chan)
}

export function * saveUserEffect (body) {
  const request = {
    url: 'profile',
    options: { body }
  }
  const chan = yield call(putEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * loadUserFlow ({ payload: avoidCache }) {
  const user = yield call(loadUserEffect, avoidCache)
  let apolloUser

  try {
    const apollo = yield call(apolloClient.query, { query: meQuery })
    apolloUser = _.get('data.me', apollo)
  } catch (err) {
    console.warn(err)
  }

  yield put(profileActions.loadRequestDone())

  if (user.error) {
    yield put(profileActions.loadError(user))
  } else {
    yield put(profileActions.loadSuccess({ ...user, apolloUser }))
  }
  yield put(authActions.loadingDone())
}

export function * clearProfileFlow () {
  yield put(profileActions.clear())
}

export function * saveUserFlow ({ payload }) {
  const profile = _.update('handicap', window.parseFloat, payload)
  const response = yield call(saveUserEffect, profile)
  if (response.error) {
    yield put(profileActions.saveError(response.error))
  } else {
    yield put(profileActions.saveSuccess(response))
    yield put(profileActions.loadRequest(Date.now()))
  }
  yield put(profileActions.saveRequestDone())
}

export default makeSaga([
  takeLatest(profileTypes.LOAD_REQUEST, loadUserFlow),
  takeLatest(profileTypes.CLEAR, clearProfileFlow),
  takeLatest(profileTypes.SAVE_REQUEST, saveUserFlow)
])
